export enum AccountType {
    INDIVIDUAL_OWNER =1,
    PROPERTY_MANAGEMENT =2,
    INDIVIDUAL_BED =3
  }